// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3FE59","gfeWrapper":"CalendarEvent_gfeWrapper__2p71-"};